/** The viewing tools' keys and radial menu, for steps with no tools of their own. */
import { useToolHotkeys } from '~/components/toolbar/shared/useToolHotkeys';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';
import RadialToolMenu from '~/components/toolbar/radialMenu/RadialToolMenu';

export default function ViewingToolShortcuts() {
    const { pan, boxZoom, rotateView, measurement } = useViewingToolEntries();
    const menu = [boxZoom, rotateView, pan, measurement];
    useToolHotkeys(menu);
    return <RadialToolMenu entries={menu} />;
}
